import { TableColumnType } from '../enums/table-column-type';
import { ColumnKey } from '../types/column-key';
import { Nillable } from '@web/utils';
import { CollectionFilterKey } from '@web/common';

export class TableColumn<Item, Filter> {
  public constructor(
    private readonly data: {
      key: ColumnKey<Item>;
      type: TableColumnType;
      sortable: boolean;
      filterable: boolean;
      width: string;
      sortKey: Nillable<string>;
      filterKey: Nillable<CollectionFilterKey<Filter>>;
      label?: Nillable<string>;
      currency?: Nillable<string>;
      frozen?: Nillable<boolean>;
    },
  ) {}

  public get key(): ColumnKey<Item> {
    return this.data.key;
  }

  public get type(): TableColumnType {
    return this.data.type;
  }

  public get sortable(): boolean {
    return this.data.sortable;
  }

  public get filterable(): boolean {
    return this.data.filterable;
  }

  public get width(): string {
    return this.data.width;
  }

  public get sortKey(): Nillable<string> {
    return this.data.sortKey;
  }

  public get filterKey(): Nillable<CollectionFilterKey<Filter>> {
    return this.data.filterKey;
  }

  public get label(): Nillable<string> {
    return this.data.label;
  }

  public get currency(): Nillable<string> {
    return this.data.currency;
  }

  public get frozen(): Nillable<boolean> {
    return this.data.frozen;
  }
}
